export default __webpack_public_path__ + "static/smoke-1-842bb75c2f59cc1f4d6425908eeb3b2c.png";